import React, { useState, useEffect, useRef } from 'react';
import Footer from './Footer';
import Navbar from './Navbar';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

type LayoutProps = {
  updatePath: (p1: string) => void;
  children: React.ReactNode;
};

const Layout = (props: LayoutProps): JSX.Element => {
  const location = useLocation();
  const [toggleMobile, setToggleMobile] = useState(false);
  const scrollRef = useRef(null);
  let scrollElement = null;

  useEffect(() => {
    props.updatePath(location.pathname);
  }, [location]);

  const backgroundScrollOff = () => {
    scrollElement = scrollRef.current;
    setToggleMobile(!toggleMobile);
    if (scrollElement !== null) {
      if (toggleMobile) {
        enableBodyScroll(scrollElement);
      } else {
        disableBodyScroll(scrollElement);
      }
    }
  };

  return (
    <div>
      <Navbar ref={scrollRef} backgroundScrollOff={backgroundScrollOff} />
      {props.children}
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
